/**
 * @generated SignedSource<<d061800d263fa5c80ad44d16844ce14e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type statusField_updateWorkItemFieldsActionRenderer$data = {
  readonly fieldId: string;
  readonly status: {
    readonly name: string | null;
  };
  readonly transitions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly to: {
          readonly name: string | null;
        } | null;
        readonly transitionId: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "statusField_updateWorkItemFieldsActionRenderer";
};
export type statusField_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: statusField_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"statusField_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "name"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "statusField_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "concreteType": "JiraStatus",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": (v0/*: any*/)
    },
    {
      "concreteType": "JiraTransitionConnection",
      "kind": "LinkedField",
      "name": "transitions",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraTransitionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraTransition",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "transitionId"
                },
                {
                  "concreteType": "JiraStatus",
                  "kind": "LinkedField",
                  "name": "to",
                  "plural": false,
                  "selections": (v0/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraStatusField"
};
})();

(node as any).hash = "fb23f08e5297002e3515870205f10d8d";

export default node;
